<div class="d-flex align-items-center" *ngIf="(currentLanguage$ | async) as currentLanguage">
  <button mat-button
          color="primary"   
          [matMenuTriggerFor]="languageMenu"  
          matTooltip="{{ 'Common.Language' | translate }}">
    <mat-icon>language</mat-icon>
    <span>{{ currentLanguage.name }}</span>
  </button>
  <mat-menu #languageMenu>
    <button *ngFor="let language of languages$ | async"
            mat-menu-item type="button"
            (click)="changeLanguage(language.code)"
            [class.active]="currentLanguage.code === language.code">
      {{ language.name }}
    </button>
  </mat-menu>
</div>
